import {
  FormattedMessage,
  injectIntl,
  type intlFormatPropTypes,
} from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import { TAX_DETAILS_ADD_ONS_PATH } from "./TaxDetails.consts";
import { TAX_DETAILS_MESSAGES } from "./TaxDetails.messages";
import { formatRegistrationTaxTypeName } from "./TaxDetails.utils";
import { useTaxDetails } from "./TaxDetailsProvider";

type TaxDetailsAddOnsNoteProps = {
  intl: intlFormatPropTypes;
};

/** Renders the host-only reminder to confirm which paid add-ons need tax added. */
const TaxDetailsAddOnsNoteComponent = ({ intl }: TaxDetailsAddOnsNoteProps) => {
  const { isHost, registrations } = useTaxDetails();

  const federalRegistration = registrations.find(
    (registration) => !registration.isSubregion,
  );

  // The federal slot is always built, so only a saved ID means one exists.
  if (!isHost || !federalRegistration?.id) {
    return null;
  }

  return (
    <div className="tw-bg-gray-100 tw-p-16 tw-rounded-4">
      <Text>
        <FormattedMessage
          {...TAX_DETAILS_MESSAGES.addOnsNote}
          values={{
            taxType: formatRegistrationTaxTypeName({
              intl,
              registration: federalRegistration,
            }),
          }}
        />{" "}
        <a
          className="tw-underline tw-text-gray-900 hover:tw-underline hover:tw-text-gray-900"
          href={TAX_DETAILS_ADD_ONS_PATH}
        >
          <FormattedMessage {...TAX_DETAILS_MESSAGES.addOnsLink} />
        </a>
      </Text>
    </div>
  );
};

const TaxDetailsAddOnsNote = injectIntl(TaxDetailsAddOnsNoteComponent);

export { TaxDetailsAddOnsNote };
